import { ApiEndpointBuilder } from "@/services/api/types";

const checkUserExists = (builder: ApiEndpointBuilder) => {
  return builder.query<CheckUserResponse, Request>({
    query: request => ({
      url: "/users/check-email",
      method: "GET",
      params: {
        email: request.email,
      },
    }),
  });
};
export default checkUserExists;

export interface Request {
  email?: string;
}

export interface CheckUserResponse {
  lastName?: string;
  firstName?: string;
  email?: string;
  existenceStatus: UserExistenceStatus;
  hasCrmVaultLicenses?: boolean;
}

export enum UserExistenceStatus {
  NotExists,
  ExistsInCurrentTenant,
  ExistsInOtherTenants,
}
